<!-- 
  Dashboard Footer Navigation
  Sticky footer providing quick access to main dashboard modules (Shipments, Declarations, etc.)
-->
<div
  class="fixed h-37.5 bottom-0 left-0 right-0 w-full p-sm border-t border-[#D7E4F4] bg-transparent z-50 transition-all duration-300"
>
  <!-- Navigation Grid (Columns scale with XL screens) -->
  <div
    class="grid grid-cols-6 xl:grid-cols-7 gap-sm items-center justify-center mx-auto"
    cdkDropList
    cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="onCardDrop($event)"
  >
    @for (card of cards(); track card.id) {
    <button
      type="button"
      (mousedown)="$event.preventDefault()"
      (click)="onCardClick(card)"
      class="relative w-full h-full group cursor-pointer outline-none rounded-xl widget-focus-ring"
      [attr.aria-label]="card.title"
      cdkDrag
      [cdkDragData]="card"
    >
      <!-- Active Marker (Floating bar above highlighted card) -->
      @if (card.isHighlighted) {
      <div
        class="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-1 bg-card-gradient rounded-full z-10 transition-all duration-300"
      ></div>
      }

      <!-- Interactive Content Wrapper (Translates up on hover without moving the Active Marker) -->
      <div
        class="relative w-full h-full transition-transform duration-300 group-hover:-translate-y-1"
      >
        <!-- Unified Folder Card Component -->
        <app-folder-card
          [id]="card.id"
          [isActive]="!!card.isHighlighted"
          [opacity]="0.5"
        ></app-folder-card>

        <!-- Card Internal Content (Icon & Title) -->
        <div
          class="relative z-10 h-full flex flex-col items-start justify-center p-4 pt-6 text-left"
        >
          <!-- Notification Badge -->
          @if (card.badgeCount && card.badgeCount > 0) {
          <div class="absolute bottom-4 right-4">
            <div
              class="text-xs font-semibold px-2 py-0.5 rounded-[4px] shadow-sm animate-in fade-in zoom-in duration-300 transition-all"
              [ngClass]="{
                'text-white bg-white/20 backdrop-blur-[2px]':
                  card.isHighlighted,
                'text-warning bg-bg-warning group-hover:text-white group-hover:bg-white/20 group-hover:backdrop-blur-[2px]':
                  !card.isHighlighted
              }"
            >
              {{ card.badgeCount }} {{ card.badgeLabel }}
            </div>
          </div>
          }

          <!-- Visual Hierarchy: Icon above Text -->
          <div class="flex flex-col items-start gap-2">
            <div class="flex justify-start w-full">
              @switch (card.icon) { @case ('airplane') {
              <ic-plane
                [startColor]="
                  card.isHighlighted
                    ? '#FFFFFF'
                    : 'var(--color-primary-start-color)'
                "
                [endColor]="
                  card.isHighlighted
                    ? '#FFFFFF'
                    : 'var(--color-primary-end-color)'
                "
                [width]="30"
                [height]="30"
                [ngClass]="{
                  'group-hover:brightness-0 group-hover:invert':
                    !card.isHighlighted
                }"
              ></ic-plane>
              } @case ('box') {
              <ic-parcelbox
                [startColor]="
                  card.isHighlighted
                    ? '#FFFFFF'
                    : 'var(--color-primary-start-color)'
                "
                [endColor]="
                  card.isHighlighted
                    ? '#FFFFFF'
                    : 'var(--color-primary-end-color)'
                "
                [width]="30"
                [height]="30"
                [ngClass]="{
                  'group-hover:brightness-0 group-hover:invert':
                    !card.isHighlighted
                }"
              ></ic-parcelbox>
              } @case ('tasks') {
              <ic-tasks
                [startColor]="
                  card.isHighlighted
                    ? '#FFFFFF'
                    : 'var(--color-primary-start-color)'
                "
                [endColor]="
                  card.isHighlighted
                    ? '#FFFFFF'
                    : 'var(--color-primary-end-color)'
                "
                [width]="30"
                [height]="30"
                [ngClass]="{
                  'group-hover:brightness-0 group-hover:invert':
                    !card.isHighlighted
                }"
              ></ic-tasks>

              } @case ('globe') {
              <ic-globe
                [startColor]="
                  card.isHighlighted
                    ? '#FFFFFF'
                    : 'var(--color-primary-start-color)'
                "
                [endColor]="
                  card.isHighlighted
                    ? '#FFFFFF'
                    : 'var(--color-primary-end-color)'
                "
                [width]="24"
                [height]="24"
                [ngClass]="{
                  'group-hover:brightness-0 group-hover:invert':
                    !card.isHighlighted
                }"
              ></ic-globe>

              } }
            </div>

            <div
              class="text-xs font-bold text-left font-inter transition-colors duration-300"
              [ngClass]="{
                'text-white': card.isHighlighted,
                'text-gray-text group-hover:text-white': !card.isHighlighted
              }"
            >
              {{ card.title }}
            </div>
          </div>
        </div>
      </div>
    </button>
    }
  </div>
</div>

<!-- Global Alerts & Notifications Drawer Overlay -->
